import React from 'react';
import RelatedArticles from '../related-articles/RelatedArticles';
import { Guide } from '../../../domain/graphcms';
import { buildArticleURLObject, slugIt } from '../../utils/links';
import { ArticleType } from '../../../domain/articleType';

export interface FeaturesGuidesWidgetProps {
  title: string,
  guides: Guide[],
}

export const FeaturesGuidesWidget: React.FC<FeaturesGuidesWidgetProps> = ({
  title,
  guides,
}) => {
  const guidesArticle = React.useMemo(() => guides.map((guide) => ({
    id: guide.id,
    title: guide.title,
    thumbnail: {
      alt: guide.imageBlock.imageAlt,
      url: guide.imageBlock.image.url,
    },
    urlObject: buildArticleURLObject({
      id: guide.id,
      slug: slugIt(guide.alternateTitle || guide.title),
    }, ArticleType.GUIDE),
  })), [guides]);

  return (
    <RelatedArticles
      title={title}
      items={guidesArticle}
    />
  );
};

export default FeaturesGuidesWidget;
